import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromSr from './saved.replies.reducer';
import { SavedRepliesState } from './saved.replies.reducer';

export const selectSRState = createFeatureSelector<SavedRepliesState>('savedreplies');

export const selectAllSavedReplies = createSelector(
    selectSRState,
    fromSr.selectAll
);

export const selectSavedReplyById = ({saved_reply_id}) => createSelector(
    selectSRState,
    sr => sr.entities[saved_reply_id]
);

export const selectDeleteLoading = createSelector(
    selectSRState,
    sr => sr.deleteLoading
);

export const selectSaveLoading = createSelector(
    selectSRState,
    sr => sr.saveLoading
);